"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ALL_VISITORS = -1;
class SegmentModel {
}
exports.SegmentModel = SegmentModel;
exports.defaultSegments = (isSDK) => {
    const allVisitorsSegment = {
        id: -1,
        name: 'SEGMENT.ALL_VISITORS',
        category: 'visit',
        creatorId: 0,
        fovCondition: '',
        isBookmarked: false,
        projectId: null,
        updaterId: 0,
        updatedAt: new Date(),
        isDefault: true,
        deletedAt: null,
    };
    const newVisitorsSegment = {
        id: 1,
        name: isSDK ? 'New sessions' : 'New visitors',
        isBookmarked: false,
        category: 'visit',
        creatorId: 0,
        fovCondition: '{"nodeType":"AND","children":[{"nodeType":"OR","children":[{"field":"visit:isNew","operator":"equals","value":"true","nodeType":"filter"}]}]}',
        projectId: null,
        updaterId: 0,
        updatedAt: null,
        isDefault: true,
        deletedAt: null,
    };
    const returningVisitorsSegment = {
        id: 2,
        name: isSDK ? 'Returning users' : 'Returning visitors',
        isBookmarked: false,
        category: 'visit',
        creatorId: 0,
        fovCondition: '{"nodeType":"AND","children":[{"nodeType":"OR","children":[{"field":"visit:isNew","operator":"equals","value":"false","nodeType":"filter"}]}]}',
        projectId: null,
        updaterId: 0,
        updatedAt: null,
        isDefault: true,
        deletedAt: null,
    };
    const visitsWithTransactionsSegment = {
        id: 7,
        name: isSDK ? 'Sessions with transactions' : 'Visits with transactions',
        isBookmarked: false,
        category: 'visit',
        creatorId: 0,
        fovCondition: '{"nodeType":"AND","children":[{"nodeType":"OR","children":[{"nodeType":"AND","children":[{"field":"visit:isBuyer","operator":"equals","value":1,"nodeType":"filter"}]}]}]}',
        projectId: null,
        updaterId: 0,
        updatedAt: null,
        isDefault: true,
        deletedAt: null,
    };
    const visitsWithoutTransactionsSegment = {
        id: 8,
        name: isSDK ? 'Sessions without transactions' : 'Visits without transactions',
        isBookmarked: false,
        category: 'visit',
        creatorId: 0,
        fovCondition: '{"nodeType":"AND","children":[{"nodeType":"OR","children":[{"nodeType":"AND","children":[{"field":"visit:isBuyer","operator":"equals","value":0,"nodeType":"filter"}]}]}]}',
        projectId: null,
        updaterId: 0,
        updatedAt: null,
        isDefault: true,
        deletedAt: null,
    };
    const nonBounceVisitsSegment = {
        id: 12,
        name: isSDK ? 'Non-bounce sessions' : 'Non-bounce visits',
        isBookmarked: false,
        category: 'visit',
        creatorId: 0,
        fovCondition: '{"nodeType":"AND","children":[{"nodeType":"OR","children":[{"field":"visit:pageviews","operator":">","value":1,"nodeType":"filter"}]}]}',
        projectId: null,
        updaterId: 0,
        updatedAt: null,
        isDefault: true,
        deletedAt: null,
    };
    const bounceVisitsSegment = {
        id: 13,
        name: isSDK ? 'Bounce sessions' : 'Bounce visits',
        isBookmarked: false,
        category: 'visit',
        creatorId: 0,
        fovCondition: '{"nodeType":"AND","children":[{"nodeType":"OR","children":[{"field":"visit:pageviews","operator":"equals","value":1,"nodeType":"filter"}]}]}',
        projectId: null,
        updaterId: 0,
        updatedAt: null,
        isDefault: true,
        deletedAt: null,
    };
    return [
        allVisitorsSegment,
        newVisitorsSegment,
        returningVisitorsSegment,
        visitsWithTransactionsSegment,
        visitsWithoutTransactionsSegment,
        nonBounceVisitsSegment,
        bounceVisitsSegment,
    ];
};
//# sourceMappingURL=segment.js.map